import { ISlideData } from "common/records/Slide";
import { ActionsUnion } from "common/reducers/UtilsTypes";
import { IPresentationData } from "common/records/Presentation";
import { createAction } from "common/reducers/Utils";

export const RECEIVE_SLIDE = "@slides/RECEIVE_SLIDE";
export const RECEIVE_SLIDES = "@slides/RECEIVE_SLIDES";

export const SlideActions = {
  receiveSlide: (slide: Partial<ISlideData>) => createAction("@slides/RECEIVE_SLIDE", { slide }),
  receiveSlides: (slides: Partial<IPresentationData>[]) => createAction("@slides/RECEIVE_SLIDES", { slides }),
};

export type SlideActions = ActionsUnion<typeof SlideActions>;
